// extracted by mini-css-extract-plugin
export var boxContainer = "onboarding-module--box-container--9GK6h";
export var boxStyle = "onboarding-module--box-style--riNXS";
export var buttonContainer = "onboarding-module--button-container--JVcLE";
export var descriptionContainer = "onboarding-module--description-container--ouprs";